import { Icon } from "@wisr/react-ui";
import React from "react";

export const referralTitle = <>Looking for a loan?</>;

export const loanOptionsCopy = (
  <>
    <p>
      You&apos;re not eligible for a Wisr loan right now, but perhaps our
      friends at LoanOptions.ai can help.
    </p>
    <p>
      LoanOptions.ai is an award-winning Australian loan broker that works with
      over 90 lenders to help people find the right loan for them.
    </p>
  </>
);

export const loanOptionsList = (
  <>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>90+ lenders</p>
    </div>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>Apply online in under 5 minutes</p>
    </div>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>No impact to your credit score</p>
    </div>
  </>
);

export const buttonSubtext = <>This won&apos;t impact your credit scores</>;

export const loanOptionsDisclaimer = (
  <>
    By continuing you&apos;re giving permission to share your details to
    LoanOptions.ai. If LoanOptions.ai helps you get a loan, Wisr will receive a
    commission.
  </>
);

export const ERROR_CALLOUT_HEADING = "Something went wrong";
export const DEFAULT_ERROR_MESSAGE = "Please try again.";
export const SCORES_REFERRAL_PRODUCT = "Credit Scores";
